export default __webpack_public_path__ + "static/media/WhatsApp.a3d36f16.jpg";